import React from "react";
import Banner from "../../../assets/images/newHome.png";
import Badge from "../../../assets/images/badge-2.png";
import Shape3 from "../../../assets/images/shape-3.png";
import { useTranslation } from "react-i18next";
import lightSlider from "../../../assets/images/light-slider-01.jpg";

const OurStory = () => {
  const [t, i18n] = useTranslation("global");
  return (
    <div className="container">
      <div className="about-content">
        <h2 className="headline-1 section-title">{t("about.journey")}</h2>

        <p className="section-text">{t("about.abtus")}</p>

        <a
          target="_blank"
          rel="noreferrer"
          href="https://live.ipms247.com/booking/book-rooms-hotellemarly"
          className="btn btn-primary"
        >
          <span className="text text-1">{t("hero.book")}</span>

          <span className="text text-2" aria-hidden="true">
          {t("hero.book")}
          </span>
        </a>
      </div>

      <figure className="about-banner">
        <img
          src={Banner}
          width="570"
          height="570"
          loading="lazy"
          alt="about banner"
          className="w-100"
          data-parallax-item
          data-parallax-speed="1"
        />

        <div
          className="abs-img abs-img-1 has-before"
          data-parallax-item
          data-parallax-speed="1.75"
        >
        </div>
      </figure>
    </div>
  );
};

export default OurStory;
